module.exports = __webpack_public_path__ + "static/person_chopping_veggies-7a07519795fe92508fb9f03b031e4c2e.png";